if (document.querySelector('.add-event') || document.querySelector('.edit-event') || document.querySelector('.delete-event') || document.querySelector('.material-form')) {
    if (document.querySelector('.form-print-submit')) {
        document.querySelector('.form-print-submit').addEventListener('click', function (event) {
        event.preventDefault();

        var allFieldsFilled = true;

        // Loop through all required input fields
        document.querySelectorAll('.required').forEach(function (input) {
            var errorMessage = input.closest('.input-group') ? input.closest('.input-group').querySelector('.error-input') : input.parentElement.querySelector('.error-input');

            if (input.type === 'select-one' && (input.value === '')) {
                errorMessage.style.display = 'flex';
                input.classList.add('form-control--error');
                input.focus();
                allFieldsFilled = false;
            } else if ((input.type === 'text' || input.type === 'email' || input.type === 'number' || input.type === 'textarea' || input.type === 'date' || input.type === 'time') && input.value.trim() === '') {
                errorMessage.style.display = 'flex';
                input.classList.add('form-control--error');
                input.focus();
                allFieldsFilled = false;
            } else if (input.type === 'file' && input.files.length === 0) {
                errorMessage.style.display = 'flex';
                input.classList.add('form-control--error');
                input.focus();
                allFieldsFilled = false;
            } else {
                errorMessage.style.display = 'none';
                input.classList.remove('form-control--error');
            }
        });

        let validLinkField = true;
        const linkInput = document.querySelector('#link');
        if (linkInput) {
            validLinkField = false;
            const errorMessage = linkInput.closest('.input-group') ? linkInput.closest('.input-group').querySelector('.error-input') : linkInput.parentElement.querySelector('.error-input');
            errorMessage.style.display = 'none';
            const urlPattern = /^(https?:\/\/)?(www\.)?([a-z\d]([a-z\d-]*[a-z\d])?(?:\.[a-z\d]([a-z\d-]*[a-z\d])?)*)\.([a-z]{2,6})(?=\/|$|\?|\#)([\w .%\/\-]*)*(\?[^#\s]*)?(\#[^\s]*)?$/;

            if (linkInput.value.trim() != "" && !urlPattern.test(linkInput.value.trim())) {
                errorMessage.style.display = 'flex';
                linkInput.classList.add('form-control--error');
                linkInput.focus();
            } else {
                linkInput.classList.remove('form-control--error');
                validLinkField = true;
            }
        }

        if (allFieldsFilled && validLinkField) {
            document.querySelector('.form-id').submit();
        } else {
            console.log('Form is not valid. allFieldsFilled: ' + allFieldsFilled + ', validLinkField: ' + validLinkField);
        }
    });
    }
    var nfImage = document.getElementById('nf-image');
    if (nfImage) {
        nfImage.addEventListener('change', function () {
            document.getElementById('fileName').textContent = this.files[0].name;
            var errorMessage = this.parentElement.querySelector('.error-input');
            errorMessage.style.display = 'none';
        });
    }
}